module.exports = __webpack_public_path__ + "static/media/2 (44).a9cffb65.jpg";